(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('OrderBagListController', OrderBagListController);

    OrderBagListController.$inject = ['$scope', '$state', 'OrderBagServiceItem', 'OrderBagServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$translate', 'OrderBagServiceItemCustom', 'formMode', 'ServiceItemCustom', '$mdDialog'];

    function OrderBagListController($scope, $state, OrderBagServiceItem, OrderBagServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, $translate, OrderBagServiceItemCustom, formMode, ServiceItemCustom, $mdDialog) {
        var vm = this;

        vm.formMode = formMode.mode;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.searchOrderBag = searchOrderBag;
        vm.getMonthCount = getMonthCount;
        vm.showSearchBoxOnMobile = showSearchBoxOnMobile;
        vm.searchBoxOnMobile = false;
        vm.serviceItem_changed = serviceItem_changed;
        vm.serviceItemId = "";
        vm.serviceItems = [];
        vm.orderBagServiceItemsQuery = [];
        vm.orderBagStatusList = null;
        vm.status_changed = status_changed;
        vm.orderBagStatus = "";
        vm.showDateSearch = showDateSearch;
        vm.showSearchByDates = false;
        vm.showSearchTextBoxOnMobile = showSearchTextBoxOnMobile;
        vm.searchTextBoxOnMobile = false;
        vm.searchOrderBagByQuery = searchOrderBagByQuery;
        vm.showIntakeData = showIntakeData;
        loaddata();

        var ShowIntakeDataDialogController = function ($scope, $mdDialog, dialogData) {
            var $ctrl = this;
            $ctrl.orderbag = dialogData;

        }
        ShowIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];

        function showIntakeData(orderbag) {
            $mdDialog.show({
                locals: {dialogData: orderbag},
                controller: ShowIntakeDataDialogController,
                templateUrl: 'app/entities/order-bag/intake-data-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: orderbag,
                clickOutsideToClose: true,
                fullscreen: false// Only for -

            })
                .then(function (answer) {

                }, function () {
                });
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();


        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }


        function loaddata() {
            if (vm.formMode == 'LoadAll') {
                loadAll();
            } else {
                vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromNow().query();
            }
            vm.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query();
            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
        }

        function loadAll() {

            vm.orderBagServiceItems = OrderBagServiceItemCustom.getAllOrderBagServiceItemByCurrentCompany().query();
        }


        function searchOrderBag() {


            var fromDateTime = null;
            var toDateTime = null;

            if ((vm.fromDateFilter == null || vm.fromDateFilter == undefined)
                &&
                (vm.toDateFilter == null || vm.toDateFilter == undefined)
            ) {
                loaddata();
                return;
            }


            if (vm.fromDateFilter == null || vm.fromDateFilter == undefined)
                fromDateTime = new Date(2000, 1, 1);
            else
                fromDateTime = new Date(vm.fromDateFilter.toString());
            if (vm.toDateFilter == null || vm.toDateFilter == undefined)
                toDateTime = new Date(3000, 1, 1);
            else
                toDateTime = new Date(vm.toDateFilter.toString());


            fromDateTime.setUTCHours(0, 0, 0);
            toDateTime.setUTCHours(0, 0, 0);

            vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromDateToDate(fromDateTime.toISOString(), toDateTime.toISOString()).query();
            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;

            vm.searchBoxOnMobile = false;

        }

        function getMonthCount(orderBagServiceItem) {
            var count = 0;
            var fromDate = new Date(orderBagServiceItem.serviceTimeSession.startDate);
            var endDate = new Date(orderBagServiceItem.serviceTimeSession.endDate);
            while (fromDate < endDate) {
                count = count + 1;
                fromDate.setDate(fromDate.getDate() + (30));
            }

            return count;
        }

        function showSearchBoxOnMobile() {
            vm.searchBoxOnMobile = !vm.searchBoxOnMobile;
        }

        function serviceItem_changed() {

            filterItems();
        }

        function status_changed() {
            filterItems();
        }

        function filterItems() {

            vm.orderBagServiceItems = vm.orderBagServiceItemsQuery;
            if ((vm.serviceItemId == "" || vm.serviceItemId == undefined) && (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)) {
                return;
            }

            vm.orderBagServiceItems = vm.orderBagServiceItems.filter(function (item) {

                if (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)
                    return ((item.serviceItem.id == vm.serviceItemId));
                if (vm.serviceItemId == "" || vm.serviceItemId == undefined)
                    return ((item.orderBag.status == vm.orderBagStatus));

                return (item.orderBag.status == vm.orderBagStatus
                    &&
                    item.serviceItem.id == vm.serviceItemId
                );
            })
        }

        function showDateSearch() {
            vm.showSearchByDates = !vm.showSearchByDates;
        }

        function showSearchTextBoxOnMobile() {
            vm.searchTextBoxOnMobile = !vm.searchTextBoxOnMobile;
        }

        function searchOrderBagByQuery() {

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            if (vm.searchQuery == null || vm.searchQuery == undefined || vm.searchQuery == "") {
                //vm.companyCustomerQueryList = vm.companyCustomers;
                return;
            }

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItemsQuery.filter(function (item) {

                return ((item.orderBag.customer.personalInfo.fisrtName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.lastName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.phoneNumber.includes(vm.searchQuery))
                    || (item.serviceItem.itemTitle.includes(vm.searchQuery))
                );
            })


        }
    }
})();
